import api from '../../api/api'

// initial state
const state = {
  status: {
    getTenantSettings: null
  },
	tenant: []
}

// actions
const actions = {
  getTenantSettings ({ commit, state }) {
    commit('setStatus', { getTenantSettings: api.status.PENDING })
    return api.getTenantSettings().then((response) => {
      commit('setStatus', { getTenantSettings: api.status.SUCCESS })
      commit('setTenantSettings', response.data)
    }).catch((error) => {
      commit('setStatus', { getTenantSettings: api.status.FAILURE })
    })
  },
}

const mutations = {
  setTenantSettings (state, settings) {
    state.tenant = settings
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}


export default {
  namespaced: true,
  state,
  actions,
  mutations
}
